// [CASH-MODE] UPI / Cash / All dropdown used on every report filter bar.
import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { PAYMENT_MODE_OPTIONS, PAYMENT_MODES } from '../constants/paymentModes';

const PaymentModeFilter = ({ value, onChange, size = 'small', sx, label = 'Payment Mode', fullWidth = false }) => (
  <FormControl size={size} sx={{ minWidth: 160, ...sx }} fullWidth={fullWidth}>
    <InputLabel id="payment-mode-filter-label">{label}</InputLabel>
    <Select
      labelId="payment-mode-filter-label"
      value={value || PAYMENT_MODES.ALL}
      label={label}
      onChange={(e) => onChange(e.target.value)}
    >
      {PAYMENT_MODE_OPTIONS.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default PaymentModeFilter;
